import { useState } from "react";
import { useSelector } from "react-redux";
import api from "../../storage/api";

const Voting = (props) => {
  const voting = useSelector((state) => state.modals.voting);
  const votingId = voting.data.id;
  const [chosenVariant, setChosenVariant] = useState("");

  const redirectToPayling = () => {
    const submitAjax = async () => {
      await fetch(`${api.apiPath}&path=cart`, {
        method: "POST",
        body: JSON.stringify({
          method: "submitVoting",
          payload: {
            voting: votingId,
            option: chosenVariant,
            order: voting.orderId
          },
        }),
        headers: {
          "Content-Type": "application/json",
        },
      });
    };

    if(chosenVariant !== ""){
        submitAjax();
    }

    localStorage.removeItem("cart");
    console.log(voting);
    if(voting.payLink){
      window.location.href = voting.payLink;
    }
    else{
      window.alert("Ошибка при формировании платежной ссылки. Попробуйте позже или обратитесь к администратору");
    }
    
    return null;
  };

  return (
    <div className="modal-window modal-window_card-voting">
      <div className="modal-controls-wrapper">
        <h5 className="modal-title">Следующее обновление</h5>
        <button
          type="button"
          className="modal-close"
          onClick={props.closeHandler}
        ></button>
      </div>
      <div className="modal-voting-description">
        <p className="modal-voting-description__p">
          Перед тем, как ты перейдешь к оплате своего заказа, мы предлагаем тебе
          принять участие в голосовании за следующее обновление.
        </p>
        <p className="modal-voting-description__p modal-voting-description__p_bold">
          Просто отметь тот вариант обновы, который тебе нравится больше всего.
          Мы добавим {voting.points} баллов к выбранному тобой варианту.
        </p>
      </div>
      <div className="modal-gray">
        <h5 className="modal-voting-title">{voting.data.title}</h5>
        <div className="modal-voting-form">
          {voting.data.options.map((item) => (
            <div
              className={
                chosenVariant === item.id
                  ? "modal-voting-option modal-voting-option_selected"
                  : "modal-voting-option"
              }
              key={item.id}
              onClick={() => {
                setChosenVariant(item.id);
              }}
            >
              <span className="modal-voting-option__marker"></span>
              <p className="modal-voting-option__description">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
      <button type="button" className="modal-btn" onClick={redirectToPayling}>
        Перейти к оплате заказа
      </button>
    </div>
  );
};

export default Voting;
